import { getToken } from "./tokenStore";
import { resolveUrl } from "./platform";

/**
 * Native: fetch an authenticated export (xlsx/JSON), write it to app cache
 * storage, then open the Android share sheet so the user can save it to Drive,
 * send it over email, etc. Mirrors the web `download()` "Save As" behaviour.
 */
export async function saveAndShare(path: string, filename: string): Promise<void> {
  const token = getToken();
  const headers = new Headers();
  if (token) headers.set("Authorization", `Bearer ${token}`);
  const res = await fetch(resolveUrl(path), { headers });
  if (!res.ok) throw new Error(`download failed (${res.status})`);
  const blob = await res.blob();
  const base64 = await blobToBase64(blob);

  const { Filesystem, Directory } = await import("@capacitor/filesystem");
  const write = await Filesystem.writeFile({
    path: filename,
    data: base64,
    directory: Directory.Cache,
  });

  const { Share } = await import("@capacitor/share");
  await Share.share({ title: filename, url: write.uri });
}

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error);
    reader.onload = () => {
      const s = String(reader.result);
      resolve(s.slice(s.indexOf(",") + 1)); // strip the "data:*;base64," prefix
    };
    reader.readAsDataURL(blob);
  });
}
